import { useState } from 'react';

const emptyForm = {
  name: '',
  email: '',
  phone: '',
  status: 'active',
  password: '',
};

function PanelUserForm({
  initialData,
  onSubmit,
  onCancel,
  submitLabel,
  isEdit = false,
}) {
  const [form, setForm] = useState({
    ...emptyForm,
    ...initialData,
    password: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.({ ...form, role: form.role || 'Staff' });
  };

  return (
    <form className="subscription-form" onSubmit={handleSubmit}>
      <div className="panel-user-form-grid">
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="panel-user-name">Full Name</label>
          <input
            id="panel-user-name"
            name="name"
            className="owner-form-input"
            value={form.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="panel-user-email">Email (Login)</label>
          <input
            id="panel-user-email"
            name="email"
            type="email"
            className="owner-form-input"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="panel-user-phone">Phone</label>
          <input
            id="panel-user-phone"
            name="phone"
            type="tel"
            className="owner-form-input"
            value={form.phone}
            onChange={handleChange}
            required
          />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="panel-user-status">Status</label>
          <select
            id="panel-user-status"
            name="status"
            className="owner-form-select"
            value={form.status}
            onChange={handleChange}
          >
            <option value="active">Active</option>
            <option value="suspended">Suspended</option>
          </select>
        </div>
        {!isEdit && (
          <div className="owner-form-group panel-user-form-full">
            <label className="owner-form-label" htmlFor="panel-user-password">Password</label>
            <input
              id="panel-user-password"
              name="password"
              type="password"
              className="owner-form-input"
              value={form.password}
              onChange={handleChange}
              placeholder="Set login password (min 6 characters)"
              required
              minLength={6}
            />
            <p className="owner-form-hint" style={{ marginTop: 6, fontSize: 13, opacity: 0.75 }}>
              Sign in with this email and password on the matching panel login.
            </p>
          </div>
        )}
      </div>
      <div className="subscription-form-actions">
        <button type="submit" className="owner-btn owner-btn-primary">{submitLabel}</button>
        {onCancel && (
          <button type="button" className="owner-btn owner-btn-secondary" onClick={onCancel}>
            Cancel
          </button>
        )}
      </div>
    </form>
  );
}

export default PanelUserForm;
